import React from 'react';
import { useSelector } from 'react-redux';

import StaticSection from './StaticSection';
import AppsLine from '../AppsLine';
import SectionSummary from '../../../_shared/components/SectionSummary';
import { aiDashboardAppsSelector } from '../../selectors';

const MarketOverview = () => {
  const apps = useSelector(aiDashboardAppsSelector);

  return (
    <div className="market-overview">
      <SectionSummary
        title="Market Overview"
        description="Track the growth of DAUs and Downloads of the AI app market. See which apps are taking share."
      >
        <AppsLine apps={apps.data?.apps} settings={apps.settings} allowQV={false} />
      </SectionSummary>

      <StaticSection variant="market-overview" height={842} />
    </div>
  );
};

export default MarketOverview;
